import React, { useEffect, useState } from 'react';
import { useFormContext } from 'clayco-component-library/lib';

const AddressValidationModal = ({model, addressLine2}) => {
    const { register } = useFormContext();
    const [data, setData] = useState(model.slice(1));
    const [selectedAddress, setSelectedAddress] = useState("");

    const handleChange = (event) => {
        setSelectedAddress(event.target.value);
    };

    return(
        <>
            { data.map((address, index) => (
                <div className='mb-3' key={index}>
                    <input {...register("selectedAddresses")} 
                        type="radio" 
                        className="btn-check"
                        name={"selectedAddresses"}
                        value={address.fullAddress}
                        id={`option${index}`} 
                        autocomplete="off" 
                        onChange={handleChange} 
                        checked={selectedAddress === address.fullAddress}
                    />
                    <label className="btn btn btn-outline-secondary me-3" htmlFor={`option${index}`}>{address.fullAddress.split(',')[0] + " " + addressLine2 + ", " + address.fullAddress.substring(address.fullAddress.indexOf(',') + 1).trim()}</label>
                </div>
            ))}
        </>
    )
};

export default AddressValidationModal;